import { render, staticRenderFns } from "./moments_good_share_detail.vue?vue&type=template&id=073b4dce&scoped=true"
import script from "./moments_good_share_detail.vue?vue&type=script&lang=js"
export * from "./moments_good_share_detail.vue?vue&type=script&lang=js"
import style0 from "./moments_good_share_detail.vue?vue&type=style&index=0&id=073b4dce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b4dce",
  null
  
)

export default component.exports